module.exports = __webpack_public_path__ + "static/media/img_qr.e8c16abd.png";